import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a55e0b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-signin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Add Configuration ", -1))
const _hoisted_3 = { class: "form-floating" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Base Url", -1))
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Static Url", -1))
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is maintenance ", -1))
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is fb login ", -1))
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is gmail login ", -1))
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is apple login ", -1))
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is phone verification ", -1))
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is email verification ", -1))
const _hoisted_19 = { class: "form-floating" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "About Us Url", -1))
const _hoisted_21 = { class: "form-floating" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Tnc Url", -1))
const _hoisted_23 = { class: "form-floating" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "FAQ Url", -1))
const _hoisted_25 = { class: "form-floating" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Privacy Policy Url", -1))
const _hoisted_27 = { class: "form-floating" }
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Country", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.base_url) = $event)),
          class: "form-control",
          placeholder: "Base Url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.base_url]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.static_url) = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Static url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.static_url]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.is_maintenance) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_maintenance]
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.is_fb_login) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_fb_login]
        ]),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.is_gmail_login) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_gmail_login]
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.is_apple_login) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_apple_login]
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.is_phone_verification) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_phone_verification]
        ]),
        _hoisted_16
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.is_email_verification) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_email_verification]
        ]),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.about_us_url) = $event)),
          class: "form-control",
          placeholder: "About Us Url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.about_us_url]
        ]),
        _hoisted_20
      ]),
      _createElementVNode("div", _hoisted_21, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.tnc_url) = $event)),
          class: "form-control",
          placeholder: "Tnc Url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.tnc_url]
        ]),
        _hoisted_22
      ]),
      _createElementVNode("div", _hoisted_23, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.data.faq_url) = $event)),
          class: "form-control",
          placeholder: "FAQ Url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.faq_url]
        ]),
        _hoisted_24
      ]),
      _createElementVNode("div", _hoisted_25, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.data.privacypolicy_url) = $event)),
          class: "form-control",
          placeholder: "Privacy Policy Url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.privacypolicy_url]
        ]),
        _hoisted_26
      ]),
      _createElementVNode("div", _hoisted_27, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.data.country_id) = $event)),
          class: "form-control",
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
            return (_openBlock(), _createElementBlock("option", {
              key: country.id,
              value: country.id
            }, _toDisplayString(country.name), 9, _hoisted_28))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.country_id]
        ]),
        _hoisted_29
      ]),
      _hoisted_30
    ], 32)
  ]))
}